(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-influencer-slider"] && !Shopify.designMode) return;
  try {
    
(function () {
  const DESKTOP_MIN_WIDTH = 1024;
  const DESKTOP_MIN_SLIDES = 5;

  function setupInfluencerSlider(root) {
    if (root.dataset.asInfluencerReady) return;
    root.dataset.asInfluencerReady = 'true';

    const slider = root.querySelector('.as-influencer__slider');
    const nav = root.querySelector('.as-influencer__nav');
    const slideCount = root.querySelectorAll('.swiper-slide').length;
    let swiper = null;

    const isDesktop = () => window.innerWidth >= DESKTOP_MIN_WIDTH;
    // Desktop shows a static 4-up grid unless there are enough slides to scroll.
    const shouldSlide = () => !isDesktop() || slideCount >= DESKTOP_MIN_SLIDES;

    function init() {
      swiper = new Swiper(slider, {
        loop: false,
        grabCursor: false,
        navigation: {
          nextEl: root.querySelector('.as-influencer__arrow--next'),
          prevEl: root.querySelector('.as-influencer__arrow--prev'),
        },
        breakpoints: {
          0: { slidesPerView: 1.1, spaceBetween: 8 },
          600: { slidesPerView: 2.2, spaceBetween: 20 },
          1024: { slidesPerView: 3.2, spaceBetween: 20 },
          1200: { slidesPerView: 4, spaceBetween: 20 },
        },
      });
    }

    function update() {
      const slide = shouldSlide();
      nav.hidden = !slide;
      if (slide && !swiper) init();
      if (!slide && swiper) {
        swiper.destroy(true, true);
        swiper = null;
      }
    }

    update();
    window.addEventListener('resize', update);
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-as-influencer]').forEach(setupInfluencerSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-pm-0082"] && !Shopify.designMode) return;
  try {
    
//Variables
const cookieProducts = 'rechargebundle_products';
const cookieFilters = 'rechargebundle_filters';

//Clears the cookies from existence
const clearCookies = () => {
  Shopify.LocalStorage.remove(cookieProducts);
  Shopify.LocalStorage.remove(cookieFilters);
}

//Helpers
const elementIsInView = (selector, callback) => {
  const observer = new MutationObserver(mutations => {
    const target = document.querySelector(selector);
    if (target) {
      observer.disconnect();
      callback(target);
    }
  });

  observer.observe(document.body, {
    //Attributes
    childList: true, 
    subtree: true 
  });
}

//Add Filters and activate them
const addFilters = () => {
  let filters = Shopify.LocalStorage.get(cookieFilters);

  if(!filters || typeof filters === 'undefined') {
    //Fallback
    filters = [];
  }

  //grab URL
  const params = new URLSearchParams(window.location.search);
  const filter = params.get('filter');

  //Check if filter is set
  if(filter) {
    Shopify.LocalStorage.set('rechargebundle_filters', [filter]);

    filters = [filter];
  }

  //Click each filter
  filters.forEach((filter) => {
    const input = document.querySelector(`li[data-rb-filter*="${filter}"] input[type="checkbox"][aria-checked="false"]`);
    if(input && typeof input !== 'undefined') {
      input.click();
      input.setAttribute("aria-checked", true);
    }
  });
}

//Each Filter / Quick Filter will append the filter functionality in the cookies
const addFilterListeners = () => {
  //Needs to be added also on the filter change
  const filters = document.querySelectorAll('.rb-filter-item input[type="checkbox"]');
  filters.forEach((filter) => filter.addEventListener('click', (e) => onFilterClick(e, filter)));

  const quickFilters = document.querySelectorAll('.pm-0082-filter');
  quickFilters.forEach((filter) => {
    //Clear all other filters
    filter.addEventListener('click', (e) => {
      const targets = document.querySelectorAll('.pm-0082-filter.active');
      targets.forEach((target) => {
        if(target !== filter) {
          target.click();
        }
      })
    });
  })
}

//Based on which filter is added / will be added it sets the cookie accordingly
const updateFilter = (name, bool) => {
  let filters = Shopify.LocalStorage.get(cookieFilters);

  if(!filters || typeof filters === 'undefined') {
    //Fallback
    filters = [];
  }

  //Find index in our cookie
  const index = filters.indexOf(name);

  if(bool && index === -1) {
    filters.push(name);
  } else if(!bool) {
    //Filter the filter with a filter while naming a filter
    filters = filters.filter(item => item !== name);
  }

  Shopify.LocalStorage.set(cookieFilters, filters);
}

//On Click event, yes we could put that in the Listener itself
const onFilterClick = (event, filter) => {
  //Update Filter saving
  updateFilter(filter.id, filter.checked);

  //Activate Quick Filters
  const label = document.querySelector(`.pm-0082-filter[for="${filter.id}"]`);
  if(label && typeof label !== 'undefined') {
    label.classList.toggle('active');
  }
}

//Each Product has several different listeners
const addProductListeners = () => {
  const products = document.querySelectorAll('.rb-item');

  products.forEach((product) => {
    //Check if the "add" exists
    const plus = product.querySelector('.rb-btn-qty-plus');
    const minus = product.querySelector('.rb-btn-qty-minus');

    //Add EventListeners
    plus.addEventListener('click', (e) => {
      onProductClick(e, product);

      //Styling workaround
      plus.classList.remove('pm-0082-add');
    })

    minus.addEventListener('click', (e) => onProductClick(e, product));
  })
}

//Add Products based on the cookie set while reload
const addProducts = () => {
  let products = Shopify.LocalStorage.get(cookieProducts);

  //Fallback
  if(!products || typeof products === undefined) {
    products = [];
  }

  //Find the products on the page
  const items = document.querySelectorAll('#build-a-box.done .rb-items-wrapper .rb-item[data-rb-item-id]');

  const targets = Array.from(items).forEach((target) => {
    const plus = target.querySelector('.rb-btn-qty-plus');
    const input = target.querySelector('.rb-input');

    //Slugify input name
    const slug = Shopify.Slugify(input.name);

    //Find position based on the slug name
    const position = Object.keys(products).findIndex((product) => product === slug);

    //Found position and return target
    if(position !== -1) {
      const product = Object.values(products)[position];

      //Praise the for loop
      for(let i = 0; i < product.quantity; i++) {
        setTimeout(() => plus.click(), 150);
      }
    }
  })
}

//Remove Products from all added items
const removeProducts = () => {
  const event = new Event('change', {
    bubbles: true
  });

  const products = document.querySelectorAll('#build-a-box.done .rb-item--added');
  products.forEach((product) => {
    //Update input values
    const input = product.querySelector('input');
    input.value = 0;

    //Fire dispatch event
    input.dispatchEvent(event)
  }) 
}

//Update the product to the cookie
const updateProduct = (target, qty, image = '') => {
  //Append to cookies
  let products = Shopify.LocalStorage.get(cookieProducts);

  //Fallback
  if(!products || typeof products === undefined) {
    products = {};
  };

  //Slugify name
  const name = Shopify.Slugify(target);
  const quantity = parseInt(qty);

  //Check if the quantity equals 0 so we bump it up by one due to delay of inputs
  if(quantity) {
    products[name] = {
      //Prevent weird wordings
      name: encodeURIComponent(target),
      image: image,
      quantity: parseInt(quantity),
    }
  } else {
    delete products[name];
  }

  //Set the cookies
  Shopify.LocalStorage.set(cookieProducts, products);
}

const updateProductTitles = () => {
  //Title
  const titles = document.querySelectorAll('.rb-title > span');
  titles.forEach(title => {
    title.innerText = title.innerText.replace('CH:', '').trim();
  });
}

//on Each Product Click
const onProductClick = (event, product) => {
  //Click is not trusted
  if(!event.isTrusted) {
    return false;
  }

  //Find Input
  const input = product.querySelector('.rb-input');
  if(!input || typeof input === undefined) {
    console.error("onProductClick", "input", input);
    throw Error;
  }

  const image = product.querySelector('.rb-item-img img');
  if(!image || typeof image === undefined || !image.src || typeof image.src === undefined) {
    console.error("onProductClick", "image", image);
    throw Error;
  }

  //Update based on the input
  updateProduct(input.name, input.value, image.src)

  //Display the Overview
  updateOverview();
}

//Observe the dom for changes in .rb-items-wrapper
const observeProducts = () => {
  /**
   * Observe the entire document, check if one of the mutation change our rb-items-wrapper
   * Then add back the Product Listeners
   */
  const observer = new MutationObserver(mutations => {
    const targets = mutations.filter((element) => element.target.classList.contains('rb-items-wrapper'));
    if(targets && targets.length) {
      //add Product Listener again, since they got lost due to re-render of Vue
      addProductListeners();

      //Add Back Product details
      addProductDetails();
    }
  });

  observer.observe(document.body, {
    //Attributes
    childList: true, 
    subtree: true 
  });
}

//Quick Filters change elements
const moveQuickFilters = () => {
  const target = document.querySelector('#build-a-box .rb-sticky-form .rb-filters');
  const elements = document.querySelectorAll('.pm-0082-filter');

  elements.forEach((element) => {
    target.append(element);
    
    //Remove hidden class
    element.classList.remove('hidden');
  });
}

//Move around again
const moveDelivery = () => {
  const target = document.querySelector('#build-a-box .rb-sticky-form .rb-form');
  const element = document.querySelector('#build-a-box .rb-subscribe-and-save-container');

  //Remove unused classes
  element.classList.remove('tpt2', 'tpt0-l');

  //Remove Class from Delivery
  const frequency = document.querySelector('.rb-frequency');
  frequency.classList.remove('tmt2', 'tmb0');

  //Append
  target.append(element);
}

//Progress Bar with count functions
const updateProgressCount = () => {
  const progressBar = document.querySelector('.rb-progress-bar');
  const progressAdded = document.querySelector('.pm-0082-progress-added')
  const progressCount = document.querySelector('.pm-0082-progress-count')

  const { rbLeft, rbAdded } = progressBar.dataset;
  const count = (parseInt(rbAdded) + parseInt(rbLeft));
  progressAdded.innerText = rbAdded;
  progressCount.innerText = count;

  //Find elements based on the amount and hide them
  const items = document.querySelectorAll('.pm-0082-item');
  items.forEach((item) => {
    const value = parseInt(item.dataset.rbCount);
    item.classList.toggle('disabled', value < rbAdded)
  })

  //Check if Progress is full
  const overlay = document.querySelector('.pm-0082-overlay');
  const overview = document.querySelector('.pm-0082-overview');
  if(rbLeft === '0' || rbLeft === 0) {
    overlay.classList.toggle('hidden');
    overview.classList.toggle('hidden');
  }
}

//Add several functions to the progress bar
const addProgress = () => {
  const target = document.querySelector('.rb-form');
  const progressWrapper = document.querySelector('.rb-progress-bar-wrapper');
  const innerProgressWrapper = document.querySelector('.rb-progress-bar-wrapper > div');

  //Move around CTA
  const cta = document.querySelector('.pm-0082-cta');
  innerProgressWrapper.append(cta);

  //Progress Bar
  const progress = document.querySelector('.pm-0082-progress')
  progressWrapper.append(progress);

  //Move ProgressBar around
  target.append(progressWrapper);

  //Grab Process data
  updateProgressCount();
}

//Clears Cookies and click the cta when finished
const addProgressListeners = () => {
  //CTA 
  const cta = document.querySelector('.pm-0082-cta');
  cta.addEventListener('click', (e) => {
    e.preventDefault();

    //find Target Button
    const target = document.querySelector('.rb-price-btn-wrapper button');

    if(!target || typeof target === undefined) {
      console.error("addProgressListeners", cta, target)
    }

    //Clear Cookies
    clearCookies();

    //Add to Cart
    target.click();

    //Remove Products
    removeProducts();

    //Close Overview
    
  });
}

//Changing Overview Structure and adding products to it
const updateOverview = () => {
  const overviewProducts = document.querySelector('.pm-0082-overview-products');

  //Get Cookies
  let products = Shopify.LocalStorage.get(cookieProducts);

  //Fallback
  if(!products || typeof products === undefined) {
    products = {};
  };

  //Get the values
  const values = Object.values(products);
  if(!values || typeof values === undefined) {
    console.error("updateOverview", "values", values);
    throw Error;
  }

  //Append html to products
  overviewProducts.innerHTML = values.map((product) => {
    const name = decodeURIComponent(product.name);
    return `<div class="pm-0082-overview-product" data-title="${name}">
        <img src="${product.image}" alt="Meal ${name}">
        <span>${product.quantity}x ${name}</span>
    </div>`;
  }).join('');

  //Update amount by reducing the values of quantity 
  const count = document.querySelector('.pm-0082-overview-count');
  count.innerText = values.reduce((a, b) => a + b.quantity, 0);

  //Grab the next biggest element and reverse the order actually
  const active = document.querySelector('.pm-0082-item.active + .pm-0082-item');
  if(active) {
    const { rbCount, rbDiscount } = active.dataset;
    const upsell = document.querySelector('.pm-0082-overview-upsell');
    const upgrade = upsell.querySelector('.pm-0082-overview-upsell a');
    const subline = upsell.querySelector('.pm-0082-overview-upsell span');

    //Mapping upgrade url
    upgrade.innerText = upgrade.innerText.replace('%s', rbCount);
    upgrade.href = active.href;

    //Change discount values
    subline.innerText = subline.innerText.replace('%s', rbDiscount);

    //Remove hidden
    upsell.classList.remove('hidden');
  }
}

//Overview listeners
const addOverviewListeners = () => {
  const overlay = document.querySelector('.pm-0082-overlay');
  const overview = document.querySelector('.pm-0082-overview');

  const closeOverview = (event) => {
    event.preventDefault();
    overlay.classList.add('hidden');
    overview.classList.add('hidden');
  }

  //CTA 
  const cta = document.querySelector('.pm-0082-overview-atc');
  cta.addEventListener('click', (e) => {
    e.preventDefault();

    //find Target Button
    const target = document.querySelector('.rb-price-btn-wrapper button');

    if(!target || typeof target === undefined) {
      console.error("addOverviewListeners", cta, target)
    }

    //Clear Cookies
    clearCookies();

    //Add to Cart
    target.click();

    //Close Update
    removeProducts();

    //Close overview
    closeOverview(e)
  });
  
  const close = document.querySelector('.pm-0082-overview-close');
  close.addEventListener('click', (e) => closeOverview(e))

  //Overlay 
  overlay.addEventListener('click', (e) => closeOverview(e))

  //Plan
  const abonnementButtonPlan = document.querySelector('.pm-0082-setting-plan');
  const abonnementButtonUnique = document.querySelector('.pm-0082-setting-unique');
  const abonnementSettings = document.querySelector('.rb-subscribe-and-save-container .rb-switch');
  const abonnementSelect = document.querySelector('.pm-0082-setting-frequency');

  abonnementButtonPlan.addEventListener('click', (e) => {
    if(abonnementButtonPlan.classList.contains('active')) {
      return;
    }

    abonnementSettings.click();
    abonnementButtonPlan.classList.add('active');
    abonnementButtonUnique.classList.remove('active');
    abonnementSelect.classList.add('active');
  });

  abonnementButtonUnique.addEventListener('click', (e) => {
    if(abonnementButtonUnique.classList.contains('active')) {
      return;
    }
    
    abonnementSettings.click();
    abonnementButtonPlan.classList.remove('active');
    abonnementButtonUnique.classList.add('active');
    abonnementSelect.classList.remove('active');

  });
}

//Add Details like carbs, rating and such things to elements
const addProductDetails = () => {
  //Find the products on the page
  const items = document.querySelectorAll('#build-a-box.done .rb-items-wrapper .rb-item[data-rb-item-id]');

  const targets = Array.from(items).forEach((element) => {
    const content = element.querySelector('.rb-item-content');
    const actions = element.querySelector('.rb-qty-wrapper');
    const input = element.querySelector('.rb-input')
    const label = element.dataset.rbItemId;
    const cta = document.querySelector('.pm-0082-cta');

    //Details
    const details = element.querySelector(`.pm-0082-details[data-target="${label}"]`);

    //Find target in our elements, and add to it 
    const target = document.querySelector(`.pm-0082-details[data-target="${label}"]`);
    const add = element.querySelector('.rb-btn-qty-plus');

    if(target && !details) {
      //Add Element only if we exist content
      if(input.value === 0 || input.value === '0') {
        add.classList.add('pm-0082-add');
        add.innerHTML = `<span class="tw1">+</span><span class="pm-0082-add-label">${cta.innerText}</span>`;
      }
    
      //Clone Element
      const div = target.cloneNode(true);
      
      //Updating the Rating ID due to double ID effect
      const rating = div.querySelector('.pm-0082-rating svg:last-child linearGradient');
      if(rating) {
        rating.id = `rating_${rating.id}`;
      }
      
      content.prepend(div);
    }
  });
}

//Overview
const addOverviewAbonnement = () => {
  //Add Plan layout?
  const target = document.querySelector('.pm-0082-setting-frequency');
  const frequency = document.querySelector('.rb-subscribe-and-save-container .rb-frequency .rb-select');

  if(frequency) {
    const aboFrequency = frequency.cloneNode(true);

    //Append
    target.append(aboFrequency);

    //Selected Index
    aboFrequency.selectedIndex = frequency.selectedIndex;

    //add Listener to the clone
    aboFrequency.addEventListener('change', (e) => {
      const frequency = document.querySelector('.rb-subscribe-and-save-container .rb-frequency .rb-select');
      frequency.selectedIndex = e.srcElement.selectedIndex;
    });
  }
}

//Observe the price changes since it will be loaded via API stuff and appended to aria-labels
const observeOverview = (element) => {
  //based on the locale and country we use numberFormat 
  const currency = new Intl.NumberFormat(`${window.Shopify.locale}-${window.Shopify.country}`, {
    style: 'currency',
    currency: window.Shopify.currency.active ?? 'EUR', //Fallback EUR cuz why not
  });

  //Prices
  const price = document.querySelector('.rb-price-btn-wrapper .rb-price span[aria-label]');

  /**
   * Observe the entire document, check if one of the mutation change our rb-items-wrapper
   * Then add back the Product Listeners
   */
  const observer = new MutationObserver(mutations => {
    //Get Mutations
    const target = mutations[0].target;

    //We need to check for point or comma in price
    //let prices = target.getAttribute('aria-label').match(/\d+(?:\.\d+)?/g);
    let prices = target.getAttribute('aria-label').match(/((?:\d|\,)*\.?\d+)/g);

    //Prices
    const oldPrice = document.querySelector('.pm-0082-overview-price-old');
    const newPrice = document.querySelector('.pm-0082-overview-price-new');

    //Plan prices, setting those fix
    const abonnementPlanPrice = document.querySelector('.pm-0082-setting-plan-price');
    const abonnementUniquePrice = document.querySelector('.pm-0082-setting-unique-price');

    if(!oldPrice || typeof oldPrice === undefined || !newPrice || typeof newPrice === undefined || !prices || typeof prices === undefined) {
      console.error('observeOverview', oldPrice, newPrice, prices);
      prices = ['0,00', '0,00'];
    }

    //Replace "," with "." due to number format issues
    prices = prices.map((price) => price.replace(',', '.'));

    //Could be that we don't have a sale price too, we update then only one of them instead of nboth
    if(prices.length && prices.length > 1) {
      oldPrice.innerText = currency.format(prices[0]);
      newPrice.innerText = currency.format(prices[1]);

      //Abonnenement
      abonnementUniquePrice.innerText = currency.format(prices[0]);
      abonnementPlanPrice.innerText = currency.format(prices[1]);
    } else if(prices.length) {
      oldPrice.innerText = '';
      newPrice.innerText = currency.format(prices[0]);
    }
  });

  observer.observe(price, {
    //Attributes
    attributes: true
  });
}

//Observe the dom for changes in .rb-items-wrapper
const observeProgressBar = () => {
  /**
   * Observe the entire document, check if one of the mutation change our rb-items-wrapper
   * Then add back the Product Listeners
   */
  const observer = new MutationObserver(mutations => {
    updateProgressCount()
  });

  observer.observe(document.querySelector('.rb-progress-bar'), {
    //Attributes
    attributes: true
  });
}

//Toggle is-sticky class on the .rb-sticky-form
const observeSticky = () => {
  const element = document.querySelector(".rb-sticky-form");

  const observer = new IntersectionObserver(([e]) => {
    e.target.classList.toggle("is-sticky", e.intersectionRatio < 1);
  },{ 
    threshold: [1],
    rootMargin: '-1px'
  });

  observer.observe(element);
}

document.addEventListener("DOMContentLoaded", (event) => {
  document.body.classList.add('as-pm-0082');

  //Basic Stuff
  //Update the overview
  updateOverview();

  //Add Listeners to existing elements that will be not created on the fly
  addProgressListeners();

  //Check for the announcement bar since it's position: fixed and change class accordingly
  elementIsInView('#qab_container', (element) => {
    document.body.classList.add('has-announcement-bar');
  });

  //Wait for Recharge Bundle loaded
  elementIsInView('#build-a-box.done .rb-sticky-form .rb-filters', (element) => {

    //Quick Filters
    moveQuickFilters();

    //Delivery Settings
    moveDelivery();

    //Add ProgressBar 
    addProgress();
  });

  elementIsInView('.rb-price-btn-wrapper .rb-price span[aria-label]', (element) => {
    //Observe
    observeOverview(element);
  });

  elementIsInView('.pm-0082-overview.at:not(.hidden)', (element) => {
    const abonnementButtonUnique = document.querySelector('.pm-0082-setting-unique');
    const abonnementSettings = document.querySelector('.rb-subscribe-and-save-container .rb-switch');

    abonnementButtonUnique.click();
    setTimeout(() => {
      abonnementSettings.click();
      addOverviewAbonnement();
    }, 150);
  });
  

  elementIsInView('#build-a-box.done .rb-sticky-form', (element) => {
    //Remove filters that are only with !important
    element.classList.remove('tmb3', 'tpt3');

    //Filters
    addFilterListeners();
    console.log("addFilterListeners");

    //Add Filters
    addFilters();
    console.log("addFilters");

    addOverviewAbonnement();
    console.log("addOverviewAbonnement")

    //Add Listeners for Overview
    addOverviewListeners();
    console.log("addOverviewListeners");

    //Observe Progressbar
    observeProgressBar();
    console.log("observeProgressBar");

    //Observe 
    observeSticky();
    console.log("observeSticky");

    /**
     * Workaround
     * This is a workaround since we set the filters, but then it takes a little bit time of the filters to 
     * re-render the site. We can't listen on any events going on in the Vue.js since it's based on $emit()-functions
     */
    elementIsInView('#build-a-box.done .rb-items-wrapper .rb-item[data-rb-item-id]', (element) => {
      //Append Details
      addProductDetails();

      //Add initial Product Listeners, when the Filters are applied and the user is doing stuff on the page
      addProductListeners();

      //Add Products
      addProducts();

      //update
      updateProductTitles();
    });
  });

  /**
   * We have to observe the rb-items-wrapper element
   * Everytime the entire rb-item is changed we need to fix so we can add all items on filter action
   * Or we can add items that actually exists in the dom
   */
  elementIsInView('#build-a-box.done .rb-items-wrapper', (element) => {
    observeProducts();
  })
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-pm-0088-interested"] && !Shopify.designMode) return;
  try {
    
  const urls = document.querySelectorAll('.pm-0088-item');

  const onClick = (e) => {
    e.preventDefault();
    const { href } = e.currentTarget;

    //Get the URLS
    const url = new URL(href);
    const params = new URLSearchParams(url.search);
    const filter = params.get('filter');

    if(!url || !params || !filter) {
      console.error("url", "params", "filter", url, params, filter);
    }

    //Check if filter is set
    if(filter) {
      Shopify.LocalStorage.set('rechargebundle_filters', [filter]);
    }

    //Redirect to url
    history.pushState({}, "", url);

    //Redirect
    window.location.replace(url);
  }
  urls.forEach((url) => url.addEventListener('click', onClick));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-pm-0088-introduction"] && !Shopify.designMode) return;
  try {
    
    if (!Element.prototype.scrollIntoViewIfNeeded) {
        Element.prototype.scrollIntoViewIfNeeded = function(centerIfNeeded = true) {
            const el = this;
            new IntersectionObserver(function([entry]) {
                const ratio = entry.intersectionRatio;

                if(ratio < 1) {
                    let place = ratio <= 0 && centerIfNeeded ? 'center' : 'nearest';

                    el.scrollIntoView({
                        behavior: "smooth",
                        block: place,
                        inline: place,
                    });
                }

                this.disconnect();
            }).observe(this);
        };
    }

    const elementIsInView = (element) => {
        const rect = element.getBoundingClientRect();
        const html = document.documentElement;
        return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || html.clientHeight) && rect.right <= (window.innerWidth || html.clientWidth));
    }

    const contentItems = document.querySelectorAll('.pm-0088-infoSection-content-item');
    const bullets = document.querySelectorAll('.pm-0088-infoSection-pager .pm-0088-pager-circle');

    const activateBullets = (index) => {
        //Remove first all classes
        //bullets.forEach((bullet) => bullet.classList.remove('active'));

        //Add them
        bullets.forEach((bullet, i) => {
            if(i <= index) {
                bullet.classList.add('active');
            } else {
                bullet.classList.remove('active');
            }
        });
    }

    const onClick = (event, element) => {
        event.preventDefault();
        const href = element.getAttribute('href');
        const target = document.querySelector(href);

        if(!target) {
            return;
        }

        const index = [...bullets].indexOf(element)
        activateBullets(index);

        //Scroll Into view
        if(target.scrollIntoViewIfNeeded) {
            target.scrollIntoViewIfNeeded()
        } else if (target.scrollIntoView) {
            target.scrollIntoView({
                behavior: "smooth"
            });
        }
    }

    const onIntersection = (entries, observer) => {
        entries.forEach((entry, index) => {
		    if (entry.isIntersecting) {
                activateBullets(entry.target.dataset.index)
		    	entry.target.classList.add("active");
		    } else {
    			entry.target.classList.remove("active");
	    	}
	    });
    }

    //When in view, activate the bullets & lines
    contentItems.forEach((element) => {
        // Intersection Observer erzeugen
        const observer = new IntersectionObserver(onIntersection, {
            root: null,
	        rootMargin: '0px',
	        threshold: 1,
        });
        observer.observe(element);
    })

    //onClick Event
    bullets.forEach((element) => {
        element.addEventListener('click', (e) => onClick(e, element));
    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["as-pm-8590"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", () => {
    const forms = document.querySelectorAll('.as-pm-8590 product-form');
    forms.forEach(form => form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const element = e.submitter;

      let formData = {
        'items': [{
          'id': element.dataset.optionId,
          'selling_plan': element.dataset.sellingPlanId,
          'quantity': 1
        }]
      };

      await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        console.log(response)

        window.RechargeBundle.onAddToCart();
      })
      .catch((error) => {
          console.log(error)
          console.error('Error:', error);
      });
    }))
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contactform-config"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', e => {
    const configNode = document.getElementById('contactform-config');
    const config = JSON.parse(configNode.dataset.config || '{}');

    const contactForm = document.getElementById('ContactForm');

    if (contactForm) { 
      const contactFormPhoneField = document.getElementById('ContactForm-phone');

      // prependix
      if (config.prependix) {
        contactFormPhoneField.removeAttribute('pattern');
        contactFormPhoneField.removeAttribute('autocomplete');
        contactFormPhoneField.setAttribute('type', 'text');
        contactFormPhoneField.setAttribute('placeholder', config.prependix);

        const contactFormPhoneFieldLabel = document.querySelector('#ContactForm #ContactForm-phone + label');
        contactFormPhoneFieldLabel.innerHTML = config.prependix;

        const contactFormText = document.getElementById('ContactForm-body');
        const contactFormSubmit = document.querySelector('#ContactForm .contact__button > button.button');
  
        var prependix = config.prependix + '\n\n------------------------------\n\n';
  
        contactForm.addEventListener('submit', e => {
            e.preventDefault();
        });
  
        contactFormSubmit.addEventListener('click', e => {
            let bodyText = contactFormText.value || '';
            contactFormText.value = prependix + bodyText;
            contactFormPhoneField.value = '007';
            contactForm.submit();
            contactFormText.value = bodyText;
            contactFormPhoneField.value = '';
        });
      }

      // hide field
      if (config.phoneFieldHide) {
        contactFormPhoneField.parentNode.style.display = 'none';
      }

      // disable field
      if (config.phoneFieldDisable) {
        contactFormPhoneField.setAttribute('disabled', 'disabled');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-login-config"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const configNode = document.getElementById('customer-login-config');
    const config = JSON.parse(configNode.dataset.config || '{}');

    if (!config.on) {
      return;
    }

    const loginForm = document.getElementById('customer_login');

    if (loginForm) {
      // update headline
      const header = document.getElementById('login');
      header.innerHTML = config.headline;
      header.style.textAlign = config.headlineAlign;

      if (config.subheadline) {
        const subheadline = document.createElement('div');
        subheadline.classList.add('subheadline');
        subheadline.innerHTML = config.subheadline;
        subheadline.style.textAlign = config.headlineAlign;

        header.parentNode.insertBefore(subheadline, header.nextSibling);
      }

      // create two columns layout
      const customerLogin = document.querySelector('.customer.login');
      const section = customerLogin.closest('.shopify-section');

      if (section) {
        const wrapper = document.createElement('div');
        const columnLeft = document.createElement('div');
        const columnRight = document.createElement('div');

        wrapper.classList.add('page-width');
        wrapper.classList.add('customer-login-flex');
        columnLeft.classList.add('column');
        columnRight.classList.add('column');

        wrapper.append(columnLeft);
        wrapper.append(columnRight);

        section.append(wrapper);

        columnRight.append(customerLogin);

        // move section padding to the new wrapper
        var sectionPaddingClass = section.id.substr(8) + '-padding';
        customerLogin.classList.remove(sectionPaddingClass);
        wrapper.classList.add(sectionPaddingClass);

        // find image and move to columnLeft
        var img = document.getElementById('customer-login-image');

        if (img) {
          columnLeft.append(img);
        }

        // set custom login form padding
        customerLogin.style.paddingTop = config.loginFormPaddingTop + 'px';
        customerLogin.style.paddingBottom = config.loginFormPaddingBottom + 'px';

        // update labels
        var resetTriggerNode = loginForm.querySelector('a[href="#recover"]');
        resetTriggerNode.innerHTML = config.loginFormButtonsResetLabel;
        resetTriggerNode.classList.add('button-reset');

        var submitTriggerNode = loginForm.querySelector('button');
        submitTriggerNode.innerHTML = config.loginFormButtonsLoginLabel;
        submitTriggerNode.classList.add('button-submit');

        var registerTriggerNode = loginForm.querySelector('a[href="/account/register"]');
        registerTriggerNode.innerHTML = config.loginFormButtonsRegisterLabel;
        registerTriggerNode.classList.add('button-register');

        // login form buttons horizontal alignment
        if (config.loginFormButtonsHorizontal) {
          const buttonWrapper = document.createElement('div');
          buttonWrapper.classList.add('button-wrapper');
          buttonWrapper.append(submitTriggerNode);
          buttonWrapper.append(registerTriggerNode);
          buttonWrapper.append(resetTriggerNode);

          loginForm.append(buttonWrapper);
        }
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class CustomHeader extends HTMLElement {
    constructor() {
      super();

      if(window.Shopify.country === 'CH') {
        //Change URL based on language
        const anchors = document.querySelectorAll('.header .list-menu li:first-child a, #menu-drawer .pm-0091-menu .pm-0091-menu-item:first-child');
        anchors.forEach(anchor => anchor.href = 'https://prepmymeal.ch/products/ch-meal-box?variant=12+Meals')
      } else if(window.Shopify.country === 'AT') {
        //Change URL based on language
        let elements = document.querySelectorAll('a.pm-0100-item');
        elements.forEach(anchor => {
          const url = new URL(anchor.href)
          const params = new URLSearchParams(url.search);
          anchor.href = `https://prepmymeal.at/products/at-meal-box?variant=12+Meals&${params.toString()}`
        })
        
        let anchors = document.querySelectorAll('.header .list-menu li:first-child a, #menu-drawer .pm-0091-menu .pm-0091-menu-item:first-child');
        anchors.forEach(anchor => anchor.href = 'https://prepmymeal.at/products/at-meal-box?variant=12+Meals')
      }
      if(window.Shopify.country === 'AT') {
        //Change URL based on language
        let anchors = document.querySelectorAll('.header .list-menu li:first-child a, #menu-drawer .pm-0091-menu .pm-0091-menu-item:first-child');
        anchors.forEach(anchor => anchor.href = 'https://prepmymeal.at/products/at-meal-box?variant=12+Meals')

        anchors = document.querySelectorAll('a.pm-0100-item');
        anchors.forEach(anchor => {
          const url = new URL(anchor.href)
          const params = new URLSearchParams(url.search);
          anchor.href = `https://prepmymeal.at/products/at-meal-box?variant=12+Meals&${params.toString()}`
        })
      }


    }

    connectedCallback() {
      //Custom PM-0100 Hover Element
      this.details = document.querySelectorAll('details[data-trigger-category]');
      this.details.forEach((element) => {
        element.addEventListener('mouseover', (e) => {
          this.details.forEach(detail => this.hide(detail));
          this.show(element)
        })
        //Hide all others
        //element.addEventListener('mouseout', (e) => this.hide(element))
      })

      //Target
      this.summaries = document.querySelectorAll('details[data-trigger-category] .mega-menu__content');
      this.summaries.forEach((element) => {
        element.addEventListener('mouseout', (e) => {
          this.details.forEach(detail => this.hide(detail));
          this.hide(element.closest('details'))
        })
      })
    }

    show(element) {
      element.setAttribute('open', true);
    }

    hide(element) {
      element.removeAttribute('open');
    }
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  customElements.define('custom-header', CustomHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neverdone-bundle-selector"] && !Shopify.designMode) return;
  try {
    
//Variables
const cookieProducts = 'rechargebundle_products';
const cookieFilters = 'rechargebundle_filters';

//Clears the cookies from existence
const clearCookies = () => {
  Shopify.LocalStorage.remove(cookieProducts);
  Shopify.LocalStorage.remove(cookieFilters);
}

//Helpers
const elementIsInView = (selector, callback) => {
  const observer = new MutationObserver(mutations => {
    const target = document.querySelector(selector);
    if (target) {
      observer.disconnect();
      callback(target);
    }
  });

  observer.observe(document.body, {
    //Attributes
    childList: true, 
    subtree: true 
  });
}

//Add Filters and activate them
const addFilters = () => {
  let filters = Shopify.LocalStorage.get(cookieFilters);

  if(!filters || typeof filters === 'undefined') {
    //Fallback
    filters = [];
  }

  //grab URL
  const params = new URLSearchParams(window.location.search);
  const filter = params.get('filter');

  //Check if filter is set
  if(filter) {
    Shopify.LocalStorage.set('rechargebundle_filters', [filter]);

    filters = [filter];
  }

  //Click each filter
  filters.forEach((filter) => {
    const input = document.querySelector(`li[data-rb-filter*="${filter}"] input[type="checkbox"][aria-checked="false"]`);
    if(input && typeof input !== 'undefined') {
      input.click();
      input.setAttribute("aria-checked", true);
    }
  });
}

// Track if listeners have been added
let filterListenersAdded = false;

//Each Filter / Quick Filter will append the filter functionality in the cookies
const addFilterListeners = () => {
  // Prevent adding listeners multiple times
  if (filterListenersAdded) {
    console.log('Filter listeners already added, skipping...');
    return;
  }
  filterListenersAdded = true;
  
  //Needs to be added also on the filter change
  const filters = document.querySelectorAll('.rb-filter-item input[type="checkbox"]');
  filters.forEach((filter) => filter.addEventListener('click', (e) => onFilterClick(e, filter)));

  const quickFilters = document.querySelectorAll('.rbn-filter');
  quickFilters.forEach((filter) => {
    //Clear all other filters
    filter.addEventListener('click', (e) => {
      console.log('Quick filter clicked:', filter.getAttribute('for'));
      console.log('Event is trusted:', e.isTrusted);
      
      const targets = document.querySelectorAll('.rbn-filter.active');
      targets.forEach((target) => {
        if(target !== filter) {
          console.log('Clearing filter:', target.getAttribute('for'));
          target.click();
        }
      })
    });
  })
}

//Based on which filter is added / will be added it sets the cookie accordingly
const updateFilter = (name, bool) => {
  let filters = Shopify.LocalStorage.get(cookieFilters);

  if(!filters || typeof filters === 'undefined') {
    //Fallback
    filters = [];
  }

  //Find index in our cookie
  const index = filters.indexOf(name);

  if(bool && index === -1) {
    filters.push(name);
  } else if(!bool) {
    //Filter the filter with a filter while naming a filter
    filters = filters.filter(item => item !== name);
  }

  Shopify.LocalStorage.set(cookieFilters, filters);
}

//On Click event, yes we could put that in the Listener itself
const onFilterClick = (event, filter) => {
  console.log('onFilterClick called for:', filter.id, 'checked:', filter.checked);
  
  //Update Filter saving
  updateFilter(filter.id, filter.checked);

  //Activate Quick Filters
  const label = document.querySelector(`.rbn-filter[for="${filter.id}"]`);
  if(label && typeof label !== 'undefined') {
    console.log('Before toggle, has active:', label.classList.contains('active'));
    label.classList.toggle('active');
    console.log('After toggle, has active:', label.classList.contains('active'));
  }
}

//Each Product has several different listeners
const addProductListeners = () => {
  // Watch for DOM changes in the items wrapper
  const itemsWrapper = document.querySelector('.rb-items-wrapper');
  if (!itemsWrapper) return;
  
  // Function to check and update all buttons
  const checkAllButtons = () => {
    const products = document.querySelectorAll('.rb-item');
    
    products.forEach((product) => {
      const input = product.querySelector('.rb-input');
      const plus = product.querySelector('.rb-btn-qty-plus');
      
      if (input && plus) {
        const value = parseInt(input.value) || 0;
        
        // Add input change listener to track products
        if (!input.dataset.hasListener) {
          input.dataset.hasListener = 'true';
          
          // Track input changes
          input.addEventListener('change', (e) => {
            const quantity = parseInt(e.target.value) || 0;
            const productTitle = product.querySelector('.rb-title')?.textContent || e.target.name;
            const productImage = product.querySelector('.rb-item-img img')?.src || '';
            
            console.log('Product quantity changed (change event):', productTitle, quantity);
            
            // Update product in localStorage
            updateProduct(productTitle, quantity, productImage);
          });
          
          // Track input event (fires on every value change)
          input.addEventListener('input', (e) => {
            const quantity = parseInt(e.target.value) || 0;
            const productTitle = product.querySelector('.rb-title')?.textContent || e.target.name;
            const productImage = product.querySelector('.rb-item-img img')?.src || '';
            
            console.log('Product quantity changed (input event):', productTitle, quantity);
            
            // Update product in localStorage
            updateProduct(productTitle, quantity, productImage);
          });
          
          // Add click listeners to quantity buttons
          const minusBtn = product.querySelector('.rb-btn-qty-minus');
          const plusBtn = product.querySelector('.rb-btn-qty-plus');
          
          if (minusBtn && !minusBtn.dataset.hasClickListener) {
            minusBtn.dataset.hasClickListener = 'true';
            minusBtn.addEventListener('click', () => {
              // Get current value before click
              const oldValue = parseInt(input.value) || 0;
              
              // Use setTimeout to get the value after Recharge updates it
              setTimeout(() => {
                const quantity = parseInt(input.value) || 0;
                const productTitle = product.querySelector('.rb-title')?.textContent || input.name;
                const productImage = product.querySelector('.rb-item-img img')?.src || '';
                
                console.log('Minus button clicked, old:', oldValue, 'new:', quantity, 'product:', productTitle);
                
                // Update product in localStorage
                updateProduct(productTitle, quantity, productImage);
              }, 50);
            });
          }
          
          if (plusBtn && !plusBtn.dataset.hasClickListener) {
            plusBtn.dataset.hasClickListener = 'true';
            plusBtn.addEventListener('click', () => {
              // Get current value before click
              const oldValue = parseInt(input.value) || 0;
              
              // Use setTimeout to get the value after Recharge updates it
              setTimeout(() => {
                const quantity = parseInt(input.value) || 0;
                const productTitle = product.querySelector('.rb-title')?.textContent || input.name;
                const productImage = product.querySelector('.rb-item-img img')?.src || '';
                
                console.log('Plus button clicked, old:', oldValue, 'new:', quantity, 'product:', productTitle);
                
                // Update product in localStorage
                updateProduct(productTitle, quantity, productImage);
              }, 50);
            });
          }
          
          // Also use a polling approach as backup - but only start after user interaction
          let lastValue = input.value;
          let pollInterval = null;
          let hasInteracted = false;
          
          const startPolling = () => {
            if (!hasInteracted && !pollInterval) {
              hasInteracted = true;
              pollInterval = setInterval(() => {
                if (input.value !== lastValue) {
                  lastValue = input.value;
                  const quantity = parseInt(input.value) || 0;
                  const productTitle = product.querySelector('.rb-title')?.textContent || input.name;
                  const productImage = product.querySelector('.rb-item-img img')?.src || '';
                  
                  console.log('Product quantity changed (polling):', productTitle, quantity);
                  
                  // Update product in localStorage
                  updateProduct(productTitle, quantity, productImage);
                }
                
                // Stop polling if element is removed from DOM
                if (!document.contains(input)) {
                  clearInterval(pollInterval);
                  pollInterval = null;
                }
              }, 500);
            }
          };
          
          // Start polling on first interaction
          input.addEventListener('focus', startPolling, { once: true });
          plusBtn?.addEventListener('click', startPolling, { once: true });
          minusBtn?.addEventListener('click', startPolling, { once: true });
        }
        
        // Only add our custom class/content if value is 0 and button doesn't already have it
        if (value === 0 && !plus.classList.contains('rbn-add')) {
          plus.classList.add('rbn-add');
          // Store original content
          plus.dataset.originalContent = plus.innerHTML;
          plus.innerHTML = `<span class="tw1">+</span><span class="rbn-add-label">Hinzufügen</span>`;
        } else if (value > 0 && plus.classList.contains('rbn-add')) {
          // Remove our customization
          plus.classList.remove('rbn-add');
          // Restore original content if available
          if (plus.dataset.originalContent) {
            plus.innerHTML = plus.dataset.originalContent;
            delete plus.dataset.originalContent;
          }
        }
      }
    });
  };
  
  // Initial check
  checkAllButtons();
  
  // Watch for any changes in the items wrapper
  const observer = new MutationObserver(() => {
    // Use requestAnimationFrame to ensure DOM has settled
    requestAnimationFrame(checkAllButtons);
  });
  
  observer.observe(itemsWrapper, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'value']
  });
  
  // Also check periodically as a fallback - less frequently to reduce overhead
  setInterval(checkAllButtons, 2000);
}

//Add Products based on the cookie set while reload
const addProducts = () => {
  console.log('=== addProducts called ===');
  let products = Shopify.LocalStorage.get(cookieProducts);
  console.log('Products from localStorage:', products);

  //Fallback
  if(!products || typeof products === undefined || Object.keys(products).length === 0) {
    console.log('No products to restore');
    return;
  }

  //Find the products on the page
  const items = document.querySelectorAll('#build-a-box.done .rb-items-wrapper .rb-item[data-rb-item-id]');
  console.log('Found items on page:', items.length);

  // Create array of products to restore
  const productsToRestore = [];
  
  Array.from(items).forEach((target, index) => {
    const plus = target.querySelector('.rb-btn-qty-plus');
    const input = target.querySelector('.rb-input');
    const titleElement = target.querySelector('.rb-title');

    if (!input || !plus) {
      console.log('Missing input or plus button for item', index);
      return;
    }

    // Try multiple ways to identify the product
    const inputName = input.name || input.getAttribute('name') || '';
    const productTitle = titleElement?.textContent?.trim() || '';
    
    // Create slug from input name
    const slugFromInput = typeof Shopify.Slugify === 'function' 
      ? Shopify.Slugify(inputName) 
      : inputName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    
    // Create slug from product title
    const slugFromTitle = typeof Shopify.Slugify === 'function' 
      ? Shopify.Slugify(productTitle) 
      : productTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
    
    console.log(`Item ${index}: Input name="${inputName}", Title="${productTitle}"`);
    console.log(`  Slug from input: "${slugFromInput}", Slug from title: "${slugFromTitle}"`);

    // Check both slugs
    let savedProduct = null;
    let matchedSlug = null;
    
    // First try input name slug
    if (products[slugFromInput]) {
      savedProduct = products[slugFromInput];
      matchedSlug = slugFromInput;
    }
    // Then try title slug
    else if (products[slugFromTitle]) {
      savedProduct = products[slugFromTitle];
      matchedSlug = slugFromTitle;
    }
    // Try to find by matching the decoded name
    else {
      for (const [slug, product] of Object.entries(products)) {
        const decodedName = decodeURIComponent(product.name);
        if (decodedName === productTitle || product.originalName === productTitle) {
          savedProduct = product;
          matchedSlug = slug;
          break;
        }
      }
    }

    if (savedProduct) {
      console.log(`Found saved product: ${savedProduct.name} with quantity ${savedProduct.quantity} (matched by ${matchedSlug})`);
      productsToRestore.push({
        element: target,
        plusButton: plus,
        input: input,
        product: savedProduct,
        targetQuantity: savedProduct.quantity
      });
    } else {
      console.log(`No saved product found for "${productTitle}" (slugs: "${slugFromInput}", "${slugFromTitle}")`);
    }
  });

  // Now restore products with better timing
  if (productsToRestore.length === 0) {
    console.log('No products matched for restoration');
    return;
  }

  console.log(`Restoring ${productsToRestore.length} products...`);
  
  // Function to click with retry
  const clickWithRetry = (item, clickNumber, maxRetries = 3) => {
    const currentValue = parseInt(item.input.value) || 0;
    
    // Check if we've reached the target
    if (currentValue >= item.targetQuantity) {
      console.log(`✓ ${decodeURIComponent(item.product.name)} already at target quantity ${item.targetQuantity}`);
      return;
    }
    
    // Check if button is disabled
    if (item.plusButton.disabled || item.plusButton.classList.contains('disabled')) {
      console.log(`Button disabled for ${decodeURIComponent(item.product.name)}, retry ${maxRetries}`);
      if (maxRetries > 0) {
        setTimeout(() => clickWithRetry(item, clickNumber, maxRetries - 1), 200);
      }
      return;
    }
    
    // Calculate how many more clicks needed
    const remainingClicks = item.targetQuantity - currentValue;
    console.log(`Clicking plus button for ${decodeURIComponent(item.product.name)} (click ${clickNumber}/${remainingClicks} remaining, current: ${currentValue}, target: ${item.targetQuantity})`);
    item.plusButton.click();
    
    // Check if click was successful after a delay
    setTimeout(() => {
      const newValue = parseInt(item.input.value) || 0;
      if (newValue === currentValue && maxRetries > 0) {
        console.log(`Click didn't update value for ${decodeURIComponent(item.product.name)}, retrying...`);
        clickWithRetry(item, clickNumber, maxRetries - 1);
      } else if (newValue < item.targetQuantity) {
        // Continue clicking if we haven't reached target
        setTimeout(() => clickWithRetry(item, clickNumber + 1, 3), 100);
      }
    }, 100);
  };

  // Start restoration with minimal delays between different products
  productsToRestore.forEach((item, index) => {
    setTimeout(() => {
      const currentValue = parseInt(item.input.value) || 0;
      console.log(`Starting restoration for ${decodeURIComponent(item.product.name)}: current=${currentValue}, target=${item.targetQuantity}`);
      
      // Only start clicking if we need to add more
      if (currentValue < item.targetQuantity) {
        clickWithRetry(item, 1);
      } else {
        console.log(`✓ ${decodeURIComponent(item.product.name)} already has correct quantity`);
      }
    }, index * 200); // Reduced to 200ms delay between starting each product
  });
  
  console.log('=== addProducts restoration started ===');
}

//Update the product to the cookie
const updateProduct = (target, qty, image) => {
  //Append to cookies
  let products = Shopify.LocalStorage.get(cookieProducts);

  //Fallback
  if(!products || typeof products === undefined) {
    products = {};
  };

  //Slugify name - with fallback if Shopify.Slugify doesn't exist
  const name = typeof Shopify.Slugify === 'function' 
    ? Shopify.Slugify(target) 
    : target.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  
  const quantity = parseInt(qty);
  
  console.log('Saving product:', {
    originalName: target,
    slugName: name,
    quantity: quantity
  });

  //Check if the quantity equals 0 so we bump it up by one due to delay of inputs
  if(quantity) {
    products[name] = {
      //Prevent weird wordings
      name: encodeURIComponent(target),
      originalName: target, // Store original name too
      image: image,
      quantity: parseInt(quantity),
    }
  } else {
    delete products[name];
  }

  //Set the cookies
  Shopify.LocalStorage.set(cookieProducts, products);
  console.log('Updated products in localStorage:', products);
}

// Removed onProductClick - let Recharge widget handle all click events

//Observe the dom for changes in .rb-items-wrapper
const observeProducts = () => {
  /**
   * Observe the entire document, check if one of the mutation change our rb-items-wrapper
   * Then add back the Product Listeners
   */
  const observer = new MutationObserver(mutations => {
    const targets = mutations.filter((element) => element.target.classList.contains('rb-items-wrapper'));
    if(targets && targets.length) {
      //add Product Listener again, since they got lost due to re-render of Vue
      addProductListeners();

      //Add Back Product details
      addProductDetails();
    }
  });

  observer.observe(document.body, {
    //Attributes
    childList: true, 
    subtree: true 
  });
}

//Quick Filters change elements
const moveQuickFilters = () => {
  const target = document.querySelector('#build-a-box .rb-sticky-form .rb-filters');
  const elements = document.querySelectorAll('.rbn-filter');

  elements.forEach((element) => {
    target.append(element);
    
    //Remove hidden class
    element.classList.remove('hidden');
  });
}

//Move around again
const moveDelivery = () => {
  const target = document.querySelector('#build-a-box .rb-sticky-form .rb-form');
  const element = document.querySelector('#build-a-box .rb-subscribe-and-save-container');

  //Remove unused classes
  element.classList.remove('tpt2', 'tpt0-l');

  //Remove Class from Delivery
  const frequency = document.querySelector('.rb-frequency');
  frequency.classList.remove('tmt2', 'tmb0');

  //Append
  target.append(element);
}

//Progress Bar with count functions
const updateProgressCount = () => {
  const progressBar = document.querySelector('.rb-progress-bar');
  const progressAdded = document.querySelector('.rbn-progress-added')
  const progressCount = document.querySelector('.rbn-progress-count')

  if (!progressBar || !progressAdded || !progressCount) {
    console.log('Progress elements not found:', {progressBar: !!progressBar, progressAdded: !!progressAdded, progressCount: !!progressCount});
    return;
  }

  const { rbLeft, rbAdded } = progressBar.dataset;
  const count = (parseInt(rbAdded) + parseInt(rbLeft));
  progressAdded.innerText = rbAdded;
  progressCount.innerText = count;

  //Find elements based on the amount and hide them
  const items = document.querySelectorAll('.rbn-item');
  items.forEach((item) => {
    const value = parseInt(item.dataset.rbCount);
    item.classList.toggle('disabled', value < rbAdded)
  })

  //Check if Progress is full
  const overlay = document.querySelector('.rbn-overlay');
  const overview = document.querySelector('.rbn-overview');
  
  console.log('=== Overlay Check ===');
  console.log('rbLeft value:', rbLeft, 'Type:', typeof rbLeft);
  console.log('rbAdded value:', rbAdded);
  console.log('Overlay element found:', !!overlay);
  console.log('Overview element found:', !!overview);
  console.log('Should show overlay:', rbLeft === '0' || rbLeft === 0);
  
  if(rbLeft === '0' || rbLeft === 0) {
    console.log('Showing overlay - removing hidden class');
    
    // Add a delay to ensure all product updates are saved
    setTimeout(() => {
      // Force a fresh read from localStorage
      console.log('About to show overlay, checking products one more time...');
      const latestProducts = Shopify.LocalStorage.get(cookieProducts);
      console.log('Latest products before showing overlay:', latestProducts);
      
      overlay.classList.remove('hidden');
      overview.classList.remove('hidden');
      console.log('Overlay hidden class after remove:', overlay.classList.contains('hidden'));
      console.log('Overview hidden class after remove:', overview.classList.contains('hidden'));
      
      // Call updateOverview when showing the overlay
      updateOverview();
    }, 500);
  }
}

//Add several functions to the progress bar
const addProgress = () => {
  const target = document.querySelector('.rb-form');
  const progressWrapper = document.querySelector('.rb-progress-bar-wrapper');
  const innerProgressWrapper = document.querySelector('.rb-progress-bar-wrapper > div');

  //Move around CTA
  const cta = document.querySelector('.rbn-cta');
  innerProgressWrapper.append(cta);

  //Progress Bar
  const progress = document.querySelector('.rbn-progress')
  progressWrapper.append(progress);

  //Move ProgressBar around
  target.append(progressWrapper);

  //Grab Process data
  updateProgressCount();
}

//Clears Cookies and click the cta when finished
const addProgressListeners = () => {
  //CTA 
  const cta = document.querySelector('.rbn-cta');
  cta.addEventListener('click', (e) => {
    e.preventDefault();

    //find Target Button
    const target = document.querySelector('.rb-price-btn-wrapper button');

    if(!target || typeof target === undefined) {
      console.error("addProgressListeners", cta, target)
    }
    

    //Clear Cookies
    clearCookies();

    //Add to Cart
    target.click();
  });
}

//Changing Overview Structure and adding products to it
const updateOverview = () => {
  console.log('=== updateOverview called ===');
  
  const overviewProducts = document.querySelector('.rbn-overview-products');
  console.log('Overview products container found:', !!overviewProducts);

  //Get Cookies
  let products = Shopify.LocalStorage.get(cookieProducts);
  console.log('Products from localStorage:', products);

  //Fallback
  if(!products || typeof products === undefined) {
    products = {};
  };

  //Get the values
  const values = Object.values(products);
  console.log('Product values:', values);
  
  // Calculate total quantity
  const totalQuantity = values.reduce((sum, product) => sum + (product.quantity || 0), 0);
  console.log('Total quantity in overview:', totalQuantity);
  console.log('Number of unique products:', values.length);
  
  if(!values || typeof values === undefined || values.length === 0) {
    console.error("updateOverview - No products found", "values", values);
    overviewProducts.innerHTML = '<p>No products selected</p>';
    return;
  }

  //Append html to products
  overviewProducts.innerHTML = values.map((product) => {
    const name = decodeURIComponent(product.name);
    return `<div class="rbn-overview-product">
        <img src="${product.image}" alt="Meal ${name}">
        <span>${product.quantity}x ${name}</span>
    </div>`;
  }).join('');

  //Update amount by reducing the values of quantity 
  const count = document.querySelector('.rbn-overview-count');
  const totalCount = values.reduce((a, b) => a + b.quantity, 0);
  console.log('Setting overview count to:', totalCount);
  if (count) {
    count.innerText = totalCount;
  } else {
    console.error('Could not find .rbn-overview-count element');
  }

  //Grab the next biggest element and reverse the order actually
  const active = document.querySelector('.rbn-item.active + .rbn-item');
  if(active) {
    const { rbCount, rbDiscount } = active.dataset;
    const upsell = document.querySelector('.rbn-overview-upsell');
    const upgrade = upsell.querySelector('.rbn-overview-upsell a');
    const subline = upsell.querySelector('.rbn-overview-upsell span');

    //Mapping upgrade url
    upgrade.innerText = upgrade.innerText.replace('%s', rbCount);
    upgrade.href = active.href;

    //Change discount values
    subline.innerText = subline.innerText.replace('%s', rbDiscount);

    //Remove hidden
    upsell.classList.remove('hidden');
  }
}

//Overview listeners
const addOverviewListeners = () => {
  const overlay = document.querySelector('.rbn-overlay');
  const overview = document.querySelector('.rbn-overview');

  const closeOverview = (event) => {
    event.preventDefault();
    overlay.classList.add('hidden');
    overview.classList.add('hidden');
  }

  //CTA 
  const cta = document.querySelector('.rbn-overview-atc');
  cta.addEventListener('click', (e) => {
    e.preventDefault();

    // Close the overlay immediately
    overlay.classList.add('hidden');
    overview.classList.add('hidden');

    //find Target Button
    const target = document.querySelector('.rb-price-btn-wrapper button');

    if(!target || typeof target === undefined) {
      console.error("addOverviewListeners", cta, target)
    }
    

    //Clear Cookies
    clearCookies();

    //Add to Cart
    target.click();
  });
  
  const close = document.querySelector('.rbn-overview-close');
  close.addEventListener('click', (e) => closeOverview(e))

  //Overlay 
  overlay.addEventListener('click', (e) => closeOverview(e))

  //Plan
  const abonnementButtonPlan = document.querySelector('.rbn-setting-plan');
  const abonnementButtonUnique = document.querySelector('.rbn-setting-unique');
  const abonnementSettings = document.querySelector('.rb-subscribe-and-save-container .rb-switch');
  const abonnementSelect = document.querySelector('.rbn-setting-frequency');

  abonnementButtonPlan.addEventListener('click', (e) => {
    if(abonnementButtonPlan.classList.contains('active')) {
      return;
    }

    abonnementSettings.click();
    abonnementButtonPlan.classList.add('active');
    abonnementButtonUnique.classList.remove('active');
    abonnementSelect.classList.add('active');
  });

  abonnementButtonUnique.addEventListener('click', (e) => {
    if(abonnementButtonUnique.classList.contains('active')) {
      return;
    }
    
    abonnementSettings.click();
    abonnementButtonPlan.classList.remove('active');
    abonnementButtonUnique.classList.add('active');
    abonnementSelect.classList.remove('active');
  });
}

//Add Details like carbs, rating and such things to elements
const addProductDetails = () => {
  // First, make sure the details container exists
  const detailsContainer = document.querySelector('.rbn-details-container');
  
  if (!detailsContainer) {
    return; // Exit if no container found
  }
  
  //Find the products on the page
  const items = document.querySelectorAll('#build-a-box.done .rb-items-wrapper .rb-item[data-rb-item-id]');

  // Process items in batches to avoid blocking
  const batchSize = 10;
  let currentIndex = 0;
  
  const processBatch = () => {
    const endIndex = Math.min(currentIndex + batchSize, items.length);
    
    for (let i = currentIndex; i < endIndex; i++) {
      const element = items[i];
      
      const content = element.querySelector('.rb-item-content');
      const actions = element.querySelector('.rb-qty-wrapper');
      const input = element.querySelector('.rb-input')
      const label = element.dataset.rbItemId;
      const cta = document.querySelector('.rbn-cta');

      //Check if details already exist in content
      const existingDetails = content ? content.querySelector('.rbn-details') : null;

      //Find target in our elements, and add to it 
      // Look in the hidden container for the template
      let target = document.querySelector(`.rbn-details-container .rbn-details[data-target="${label}"]`);
      const add = element.querySelector('.rb-btn-qty-plus');
    
    // If not found by product ID, try to find by variant ID
    if (!target) {
      // The label might be a variant ID, so check if any .rbn-details contains this variant
      const allDetails = document.querySelectorAll('.rbn-details-container .rbn-details');
      for (const detail of allDetails) {
        const variantSpans = detail.querySelectorAll('.rbn-variants span[data-variant-id]');
        for (const span of variantSpans) {
          if (span.dataset.variantId === label) {
            target = detail;
            break;
          }
        }
        if (target) break;
      }
    }
    
    // Try to find by title if still not found
    if (!target) {
      const itemTitle = element.querySelector('.rb-title')?.textContent?.trim();
      
      if (itemTitle) {
        // Try to find by matching title
        const allDetails = document.querySelectorAll('.rbn-details-container .rbn-details');
        for (const detail of allDetails) {
          if (detail.dataset.productTitle === itemTitle) {
            target = detail;
            break;
          }
        }
      }
    }
    

    if(target && !existingDetails) {
      
      //Update button state
      if(input && add) {
        const value = parseInt(input.value) || 0;
        if (value === 0 && !add.classList.contains('rbn-add')) {
          add.classList.add('rbn-add');
          add.dataset.originalContent = add.innerHTML;
          add.innerHTML = `<span class="tw1">+</span><span class="rbn-add-label">Hinzufügen</span>`;
        }
      }
    
      //Clone Element
      const div = target.cloneNode(true);
      
      // Remove the hidden class from the cloned element if it exists
      div.classList.remove('hidden');
      
      //Updating the Rating ID due to double ID effect
      const rating = div.querySelector('.rbn-rating svg:last-child linearGradient');
      if(rating) {
        rating.id = `rating_${rating.id}`;
      }
      
      if (content) {
        content.prepend(div);
      }
    } else if (!target) {
      
      // Since no products are configured in the section, create a placeholder detail element
      if (content && !existingDetails) {
        const placeholderDiv = document.createElement('div');
        placeholderDiv.className = 'rbn-details';
        placeholderDiv.setAttribute('data-target', label);
        placeholderDiv.innerHTML = `
          <div class="rbn-detail">
            <span class="rbn-detail-value">-</span>
            <span class="rbn-detail-label">kcal</span>
          </div>
          <div class="rbn-detail">
            <span class="rbn-detail-value">-</span>
            <span class="rbn-detail-label">Protein</span>
          </div>
          <div class="rbn-detail">
            <span class="rbn-detail-value">-</span>
            <span class="rbn-detail-label">Carbs</span>
          </div>
          <div class="rbn-detail">
            <span class="rbn-detail-value">-</span>
            <span class="rbn-detail-label">Fett</span>
          </div>
          <div class="rbn-rating"></div>
        `;
        
        //Update button state
        if(input && add) {
          const value = parseInt(input.value) || 0;
          if (value === 0 && !add.classList.contains('rbn-add')) {
            add.classList.add('rbn-add');
            add.dataset.originalContent = add.innerHTML;
            add.innerHTML = `<span class="tw1">+</span><span class="rbn-add-label">Hinzufügen</span>`;
          }
        }
        
        content.prepend(placeholderDiv);
      }
    }
    }
    
    currentIndex = endIndex;
    
    // If there are more items to process, schedule next batch
    if (currentIndex < items.length) {
      requestAnimationFrame(processBatch);
    }
  };
  
  // Start processing
  processBatch();
}

//Overview
const addOverviewAbonnement = () => {
  //Add Plan layout?
  const target = document.querySelector('.rbn-setting-frequency');
  const frequency = document.querySelector('.rb-subscribe-and-save-container .rb-frequency .rb-select');

  if(frequency) {
    const aboFrequency = frequency.cloneNode(true);

    //Append
    target.append(aboFrequency);

    //Selected Index
    aboFrequency.selectedIndex = frequency.selectedIndex;

    //add Listener to the clone
    aboFrequency.addEventListener('change', (e) => {
      const frequency = document.querySelector('.rb-subscribe-and-save-container .rb-frequency .rb-select');
      frequency.selectedIndex = e.srcElement.selectedIndex;
    });
  }
}

//Shorten frequency dropdown text by removing "Lieferung"
const shortenFrequencyText = () => {
  const frequencySelect = document.querySelector('.rb-subscribe-and-save-container .rb-frequency .rb-select');
  
  if (frequencySelect) {
    // Update all options
    const options = frequencySelect.querySelectorAll('option');
    options.forEach(option => {
      // Get the text content
      let text = option.textContent || option.innerText;
      
      // Remove "Lieferung " from the beginning if it exists
      if (text && text.includes('Lieferung jede')) {
        text = text.replace('Lieferung jede', 'Jede');
        option.textContent = text;
      }
    });
    
    // Also observe for changes in case options are dynamically updated
    const observer = new MutationObserver(() => {
      const options = frequencySelect.querySelectorAll('option');
      options.forEach(option => {
        let text = option.textContent || option.innerText;
        if (text && text.includes('Lieferung jede')) {
          text = text.replace('Lieferung jede', 'Jede');
          option.textContent = text;
        }
      });
    });
    
    observer.observe(frequencySelect, { childList: true, subtree: true });
  }
}

//Observe the price changes since it will be loaded via API stuff and appended to aria-labels
const observeOverview = (element) => {
  //based on the locale and country we use numberFormat 
  const currency = new Intl.NumberFormat(`${window.Shopify.locale}-${window.Shopify.country}`, {
    style: 'currency',
    currency: window.Shopify.currency.active ?? 'EUR', //Fallback EUR cuz why not
  });

  //Prices
  const price = document.querySelector('.rb-price-btn-wrapper .rb-price span[aria-label]');

  /**
   * Observe the entire document, check if one of the mutation change our rb-items-wrapper
   * Then add back the Product Listeners
   */
  const observer = new MutationObserver(mutations => {
    //Get Mutations
    const target = mutations[0].target;

    //We need to check for point or comma in price
    //let prices = target.getAttribute('aria-label').match(/\d+(?:\.\d+)?/g);
    let prices = target.getAttribute('aria-label').match(/((?:\d|\,)*\.?\d+)/g);

    //Prices
    const oldPrice = document.querySelector('.rbn-overview-price-old');
    const newPrice = document.querySelector('.rbn-overview-price-new');

    //Plan prices, setting those fix
    const abonnementPlanPrice = document.querySelector('.rbn-setting-plan-price');
    const abonnementUniquePrice = document.querySelector('.rbn-setting-unique-price');

    if(!oldPrice || typeof oldPrice === undefined || !newPrice || typeof newPrice === undefined || !prices || typeof prices === undefined) {
      console.error('observeOverview', oldPrice, newPrice, prices);
      prices = ['0,00', '0,00'];
    }

    //Replace "," with "." due to number format issues
    prices = prices.map((price) => price.replace(',', '.'));

    //Could be that we don't have a sale price too, we update then only one of them instead of nboth
    if(prices.length && prices.length > 1) {
      oldPrice.innerText = currency.format(prices[0]);
      newPrice.innerText = currency.format(prices[1]);

      //Abonnenement
      abonnementUniquePrice.innerText = currency.format(prices[0]);
      abonnementPlanPrice.innerText = currency.format(prices[1]);
    } else if(prices.length) {
      oldPrice.innerText = '';
      newPrice.innerText = currency.format(prices[0]);
    }
  });

  observer.observe(price, {
    //Attributes
    attributes: true
  });
}

//Observe the dom for changes in .rb-items-wrapper
const observeProgressBar = () => {
  /**
   * Observe the entire document, check if one of the mutation change our rb-items-wrapper
   * Then add back the Product Listeners
   */
  const observer = new MutationObserver(mutations => {
    console.log('=== Progress Bar Mutation Detected ===');
    mutations.forEach(mutation => {
      if (mutation.type === 'attributes') {
        console.log('Changed attribute:', mutation.attributeName);
        console.log('New value:', mutation.target.getAttribute(mutation.attributeName));
      }
    });
    updateProgressCount()
  });

  observer.observe(document.querySelector('.rb-progress-bar'), {
    //Attributes
    attributes: true
  });
}

//Toggle is-sticky class on the .rb-sticky-form
const observeSticky = () => {
  const element = document.querySelector(".rb-sticky-form");

  const observer = new IntersectionObserver(([e]) => {
    e.target.classList.toggle("is-sticky", e.intersectionRatio < 1);
  },{ 
    threshold: [1],
    rootMargin: '-1px'
  });

  observer.observe(element);
}

document.addEventListener("DOMContentLoaded", (event) => {
  // console.log('=== RBN Section Script Starting (DOMContentLoaded) ===');
  
  
  // Check if our custom section exists on the page (just for reference)
  const sectionContainer = document.querySelector('.rbn-section');
  // console.log('Custom section (.rbn-section) found:', sectionContainer);
  
  // Try alternative selectors for our custom section
  const sectionByClass = document.querySelector('[class*="rbn"]');
  // console.log('Any element with "rbn" in class:', sectionByClass);
  
  // Also check for the section by ID or other potential selectors
  const sectionById = document.querySelector('[id*="recharge-neverdone"]');
  // console.log('Section by ID pattern found:', sectionById);
  
  // Check all divs to see what's there
  const allDivs = document.querySelectorAll('div');
  // console.log('Total div elements on page:', allDivs.length);
  
  // Look for our specific section content
  const rbnItems = document.querySelector('.rbn-items');
  // console.log('Found .rbn-items:', rbnItems);
  
  const rbnFilter = document.querySelector('.rbn-filter-container');
  // console.log('Found .rbn-filter-container:', rbnFilter);
  
  const shopifySections = document.querySelectorAll('.shopify-section');
  // console.log('Total Shopify sections on page:', shopifySections.length);
  
  // List all shopify section IDs to debug
  shopifySections.forEach((section, index) => {
    // console.log(`  Shopify section ${index}:`, section.id || 'no-id', section.className);
  });
  
  // Check if this script is even running (it obviously is if we see logs)
  // console.log('Current script location:', window.location.href);
  
  // Debug: Check what's in the body
  // console.log('Body HTML length:', document.body.innerHTML.length);
  // console.log('Body contains "rbn-section":', document.body.innerHTML.includes('rbn-section'));
  
  // Check if the section HTML is in a script tag (Shopify sometimes does this)
  const scriptTags = document.querySelectorAll('script[type="text/template"], script[data-section-type]');
  // console.log('Template script tags found:', scriptTags.length);
  
  // Instead of exiting, let's proceed anyway and look for Recharge widgets
  // The section might be loaded differently or have different markup
  if (!sectionContainer) {
    // console.log('⚠️ Custom section not found, but will still check for Recharge widgets...');
    // console.log('⚠️ This might mean the section is not included on this page.');
    // console.log('⚠️ Make sure the "Recharge Bundle neverdone" section is added to your page in Shopify admin.');
    // Don't return here - let's continue and see if we can find Recharge
  }
  
  // Check if there's a Recharge app on the page
  // console.log('Checking for Recharge app on page...');
  let rechargeContainer = document.querySelector('#build-a-box, .shopify-app-block.recharge-bundles-widget, .rb-app');
  // console.log('Initial Recharge container found:', rechargeContainer);
  
  // If found, apply styles immediately
  if (rechargeContainer) {
    // console.log('Recharge app found immediately - applying styles to body');
    document.body.classList.add('rbn-custom-styles');
    
    // Check for announcement bar
    const announcementBar = document.querySelector('#qab_container');
    if (announcementBar) {
      document.body.classList.add('has-announcement-bar');
    }
  } else {
    // console.log('No Recharge app found - will wait for it to load');
  }
  
  // console.log('Proceeding with style application and observer setup...');
  
  // Function to add custom styles to Recharge sections
  function addCustomStylesToRecharge() {
    // console.log('=== Checking and applying custom styles for Recharge ===');
    
    // Check if body already has the class
    const alreadyStyled = document.body.classList.contains('rbn-custom-styles');
    if (alreadyStyled) {
      // console.log('Body already has rbn-custom-styles class');
    }
    
    // Check for each selector individually to debug
    const selectors = [
      '.shopify-app-block.recharge-bundles-widget',
      '.rb-app',
      '#build-a-box',
      '#recharge-bundles',
      '[data-app="rechargepayments.com"]'
    ];
    
    let rechargeFound = false;
    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      // console.log(`Selector "${selector}" found:`, elements.length, 'elements');
      if (elements.length > 0) {
        rechargeFound = true;
        // console.log('  Elements:', elements);
      }
    });
    
    // If any Recharge element is found, add the class to body
    if (rechargeFound) {
      // console.log('✅ Recharge elements found - adding rbn-custom-styles to body');
      document.body.classList.add('rbn-custom-styles');
      
      // Also check if we have an announcement bar
      const announcementBar = document.querySelector('#qab_container');
      if (announcementBar) {
        document.body.classList.add('has-announcement-bar');
        // console.log('✅ Added has-announcement-bar class to body');
      }
    } else {
      // console.log('⚠️ No Recharge elements found yet');
    }
    
    // Summary of what was done
    // console.log('=== Summary ===');
    // console.log('Body has rbn-custom-styles:', document.body.classList.contains('rbn-custom-styles'));
    // console.log('Body classes:', document.body.className);
    
    // Always check for Recharge elements and initialization
    // console.log('Checking for Recharge elements to initialize functions...');
    
    // Check for build-a-box (with or without .done class)
    const buildABox = document.querySelector('#build-a-box');
    const buildABoxDone = document.querySelector('#build-a-box.done');
    
    if (buildABox) {
      // console.log('Found #build-a-box element');
      // console.log('  Has .done class:', buildABox.classList.contains('done'));
      // console.log('  Classes:', buildABox.className);
      
      // If no .done class yet, wait for it
      if (!buildABox.classList.contains('done')) {
        // console.log('⚠️ #build-a-box found but missing .done class - waiting for it...');
        elementIsInView('#build-a-box.done', (element) => {
          // console.log('✅ #build-a-box.done is now available!');
          // Re-run initialization when .done is added
          initializeRechargeFeatures();
        });
      } else {
        // Has .done class, initialize now
        // console.log('Found #build-a-box.done - initializing features...');
        initializeRechargeFeatures();
      }
    } else {
      // console.log('⚠️ #build-a-box not found yet');
    }
  }
  
  // Function to initialize all Recharge features
  function initializeRechargeFeatures() {
    // console.log('=== Initializing Recharge features ===');
    
    // Use requestAnimationFrame to avoid blocking the main thread
    requestAnimationFrame(() => {
      // Check for sticky form and filters
      const stickyFormFilters = document.querySelector('#build-a-box.done .rb-sticky-form .rb-filters');
      if (stickyFormFilters && !stickyFormFilters.dataset.initialized) {
        // console.log('Found sticky form filters - initializing...');
        stickyFormFilters.dataset.initialized = 'true';
        moveQuickFilters();
        moveDelivery();
        shortenFrequencyText();
        addProgress();
      }
      
      // Check for sticky form
      const stickyForm = document.querySelector('#build-a-box.done .rb-sticky-form');
      if (stickyForm && !stickyForm.dataset.initialized) {
        // console.log('Found sticky form - initializing listeners...');
        stickyForm.dataset.initialized = 'true';
        stickyForm.classList.remove('tmb3', 'tpt3');
        addFilterListeners();
        addFilters();
        addOverviewAbonnement();
        addOverviewListeners();
        observeProgressBar();
        observeSticky();
      }
    });
    
    // Delay product initialization to improve initial load
    setTimeout(() => {
      // Check for product items
      const productItems = document.querySelector('#build-a-box.done .rb-items-wrapper .rb-item[data-rb-item-id]');
      if (productItems && !productItems.dataset.detailsAdded) {
        productItems.dataset.detailsAdded = 'true';
        
        // Use requestIdleCallback if available, otherwise setTimeout
        if ('requestIdleCallback' in window) {
          requestIdleCallback(() => {
            addProductDetails();
            addProductListeners();
          }, { timeout: 1000 });
        } else {
          setTimeout(() => {
            addProductDetails();
            addProductListeners();
          }, 100);
        }
        
        // Delay addProducts to ensure Recharge widget is ready
        setTimeout(() => {
          addProducts();
        }, 800);
      }
      
      // Check for items wrapper
      const itemsWrapper = document.querySelector('#build-a-box.done .rb-items-wrapper');
      if (itemsWrapper && !itemsWrapper.dataset.observing) {
        // console.log('Found items wrapper - observing products...');
        itemsWrapper.dataset.observing = 'true';
        observeProducts();
      }
      
      // Check for price button
      const priceBtn = document.querySelector('.rb-price-btn-wrapper .rb-price span[aria-label]');
      if (priceBtn && !priceBtn.dataset.observing) {
        // console.log('Found price button - observing overview...');
        priceBtn.dataset.observing = 'true';
        observeOverview(priceBtn);
      }
    }, 500);
  }
  
  // Apply styles immediately
  addCustomStylesToRecharge();
  
  // Also check after a short delay in case Recharge loads asynchronously
  setTimeout(addCustomStylesToRecharge, 500);
  setTimeout(addCustomStylesToRecharge, 1500);
  
  // Watch for dynamically added Recharge sections
  const observer = new MutationObserver((mutations) => {
    
    let shouldCheck = false;
    
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        // Check if any added nodes might be Recharge sections
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const element = node;
            // Check for any element that might be Recharge-related
            const elementHTML = element.outerHTML || '';
            if (element.id === 'build-a-box' || 
                element.classList.contains('rb-app') ||
                element.classList.contains('recharge-bundles-widget') ||
                elementHTML.includes('recharge') ||
                elementHTML.includes('rb-app') ||
                elementHTML.includes('build-a-box') ||
                element.querySelector && (
                  element.querySelector('.rb-app, #build-a-box, [class*="recharge"], [id*="recharge"]')
                )) {
              shouldCheck = true;
              // console.log('Detected potential Recharge element added:', element);
              break;
            }
          }
        }
      }
    }
    
    if (shouldCheck) {
      // console.log('Recharge section might have been added, rechecking...');
      setTimeout(addCustomStylesToRecharge, 100); // Small delay to let it fully render
    }
  });
  
  // Start observing the document for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Mark our section as active if it exists
  const finalSectionCheck = document.querySelector('.rbn-section');
  if (finalSectionCheck) {
    finalSectionCheck.classList.add('rbn-active');
    // console.log('Added rbn-active class to section');
  } else {
    // console.log('Still no .rbn-section found, but styles may still work on Recharge widgets');
  }
  
  // Also try to find Recharge sections on window load (in case they load late)
  window.addEventListener('load', () => {
    // console.log('=== Window loaded - rechecking for Recharge ===');
    addCustomStylesToRecharge();
  });
  
  // Final fallback - check periodically for a few seconds
  let checkCount = 0;
  const maxChecks = 10;
  const checkInterval = setInterval(() => {
    checkCount++;
    // console.log(`=== Periodic check ${checkCount}/${maxChecks} for Recharge sections ===`);
    
    // On first check, do a comprehensive search
    if (checkCount === 1) {
      // console.log('Comprehensive element search:');
      
      // Search for any element with "recharge" in class or id
      const rechargeByClass = document.querySelectorAll('[class*="recharge" i], [class*="rb-" i], [class*="rbn" i]');
      // console.log(`Elements with recharge/rb/rbn in class: ${rechargeByClass.length}`);
      if (rechargeByClass.length > 0) {
        rechargeByClass.forEach((el, i) => {
          if (i < 5) { // Only log first 5 to avoid spam
            // console.log(`  ${i}: ${el.tagName}.${el.className}`);
          }
        });
        
        // Check if any are actual Recharge app elements
        const rbApp = Array.from(rechargeByClass).find(el => 
          el.classList.contains('rb-app') || 
          el.classList.contains('recharge-bundles-widget') ||
          el.id === 'build-a-box'
        );
        
        if (rbApp && !document.body.classList.contains('rbn-custom-styles')) {
          // console.log('🎯 Found Recharge app element in comprehensive search!');
          addCustomStylesToRecharge();
        }
      }
      
      // Search for any element with "recharge" in id
      const rechargeById = document.querySelectorAll('[id*="recharge" i], [id*="bundle" i]');
      // console.log(`Elements with recharge/bundle in ID: ${rechargeById.length}`);
      if (rechargeById.length > 0) {
        rechargeById.forEach((el, i) => {
          if (i < 5) { // Only log first 5
            // console.log(`  ${i}: ${el.tagName}#${el.id}`);
          }
        });
      }
      
      // Check for iframes (Recharge might be in an iframe)
      const iframes = document.querySelectorAll('iframe');
      // console.log(`Iframes found: ${iframes.length}`);
      iframes.forEach((iframe, i) => {
        // console.log(`  Iframe ${i}: src=${iframe.src || 'no-src'}`);
      });
      
      // Check for Recharge-related scripts
      const scripts = document.querySelectorAll('script[src*="recharge"], script[src*="bundle"]');
      // console.log(`Recharge-related scripts: ${scripts.length}`);
      scripts.forEach((script, i) => {
        // console.log(`  Script ${i}: ${script.src}`);
      });
      
      // Check for any shopify app blocks
      const appBlocks = document.querySelectorAll('.shopify-app-block');
      // console.log(`Shopify app blocks found: ${appBlocks.length}`);
      appBlocks.forEach((block, i) => {
        if (i < 3) {
          // console.log(`  App block ${i}:`, block.className, block.id || 'no-id');
        }
      });
    }
    
    addCustomStylesToRecharge();
    
    // Stop checking after max attempts or if we found sections
    const foundSections = document.querySelectorAll('.rbn-custom-styles');
    if (checkCount >= maxChecks || foundSections.length > 0) {
      clearInterval(checkInterval);
      // console.log(`=== Stopping periodic checks. Found ${foundSections.length} styled sections ===`);
    }
  }, 500);

  //Basic Stuff
  //Update the overview - commented out since we let Recharge handle product updates
  // updateOverview();

  //Add Listeners to existing elements that will be not created on the fly
  addProgressListeners();

  //Check for the announcement bar since it's position: fixed and change class accordingly
  elementIsInView('#qab_container', (element) => {
      document.body.classList.add('has-announcement-bar');
  });

  //Wait for Recharge Bundle loaded
  elementIsInView('#build-a-box.done .rb-sticky-form .rb-filters', (element) => {

    //Quick Filters
    moveQuickFilters();

    //Delivery Settings
    moveDelivery();
    
    //Shorten frequency text
    shortenFrequencyText();

    //Add ProgressBar 
    addProgress();
  });

  elementIsInView('.rb-price-btn-wrapper .rb-price span[aria-label]', (element) => {
    //Observe
    observeOverview(element);
  });

  elementIsInView('#build-a-box.done .rb-sticky-form', (element) => {
    //Remove filters that are only with !important
    element.classList.remove('tmb3', 'tpt3');

    //Filters
    addFilterListeners();
    // console.log("addFilterListeners");

    //Add Filters
    addFilters();
    // console.log("addFilters");

    addOverviewAbonnement();
    // console.log("addOverviewAbonnement")

    //Add Listeners for Overview
    addOverviewListeners();
    // console.log("addOverviewListeners");

    //Observe Progressbar
    observeProgressBar();
    // console.log("observeProgressBar");

    //Observe 
    observeSticky();
    // console.log("observeSticky");

    /**
     * Workaround
     * This is a workaround since we set the filters, but then it takes a little bit time of the filters to 
     * re-render the site. We can't listen on any events going on in the Vue.js since it's based on $emit()-functions
     */
    //setTimeout(() => {
      //[data-rb-item-id] will be added when the bundle is done loaded
      elementIsInView('#build-a-box.done .rb-items-wrapper .rb-item[data-rb-item-id]', (element) => {

        //Append Details
        addProductDetails();

        //Add initial Product Listeners, when the Filters are applied and the user is doing stuff on the page
        addProductListeners();

        //Add Products - with delay to ensure widget is ready
        setTimeout(() => {
          addProducts();
        }, 800);
      });
    //}, 250);
  });

  /**
   * We have to observe the rb-items-wrapper element
   * Everytime the entire rb-item is changed we need to fix so we can add all items on filter action
   * Or we can add items that actually exists in the dom
   */
  elementIsInView('#build-a-box.done .rb-items-wrapper', (element) => {
    observeProducts();
  })
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recharge-bundle-config"] && !Shopify.designMode) return;
  try {
    
  /* Recharge bundle customizations */
  (function () {
    var bundle,form,filters,mobileFilterMenuButtonIcon,mobileFilterMenuButtonTextNode,mobileFilterMenuButtonIconImage;

    const configNode = document.getElementById('recharge-bundle-config');
    const config = JSON.parse(configNode.dataset.config || '{}');

    // The moment build-a-box is available does not mean all other components are loaded also internally, yet.
    // So we wait until the form and filters are there.
    function boot() {
      const i = setInterval(function () {
        form = document.querySelector('#build-a-box .rb-sticky-form .rb-form');
        filters = document.querySelector('#build-a-box .rb-box-builder > .rb-filters');
    
        if (form && filters) {
          clearInterval(i);

          // now all components "should" be available, so move on

          // Add icon to mobile filter button
          if (config.customFilterButton === true) {
            mobileFilterMenuButtonIcon = 'data:image/png;base64,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';
            mobileFilterMenuButtonTextNode = document.querySelector('.rb-filters-nav > a > span');

            mobileFilterMenuButtonIconImage = document.createElement('img');
            mobileFilterMenuButtonIconImage.id = 'mobile-filter-menu-button-icon-image';
            mobileFilterMenuButtonIconImage.src = mobileFilterMenuButtonIcon;
            
            mobileFilterMenuButtonTextNode.insertAdjacentElement("beforebegin", mobileFilterMenuButtonIconImage);
          }

          // Change mobile filter button label
          if (config.customFilterButtonLabel.length > 0) {
            mobileFilterMenuButtonTextNode.innerHTML = config.customFilterButtonLabel || 'Mehr Filter';
          }

          // Move the filters into sticky area
          if (config.filterButtonInBar === true) {
            if (form.children.length > 0) {
              form.children[0].style.display = 'none';
              form.children[0].insertAdjacentElement("afterend", filters);
            }
          }
        }
      }, 500);
    }

    // first, find the bundle component
    const i = setInterval(function () {
      bundle = document.getElementById('build-a-box');
  
      if (bundle) {
        clearInterval(i);
  
        boot();

        bundle.classList.add('done')
      }
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();
})();
